// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UpdateExecutionAmountInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payroll/update_execution_amount/{id}
 *
 * Validates input for manually updating an execution amount.
 */
import { registerContract } from './validate'

export interface Payroll_UpdateExecutionAmountInput {
amount: number
}

registerContract('Payroll_UpdateExecutionAmountInput', {
  amount: { type: 'number',  required: true },
})
